/**
 * Lab and run management service
 */

import { apiClient } from './api';
import {
  Lab,
  LabSummary,
  Run,
  RunCreate,
  RunExtend,
  Grade,
  LabQueryParams,
  QueryParams,
} from '../types';

export class LabService {
  async getLabs(params?: LabQueryParams): Promise<LabSummary[]> {
    return apiClient.get<LabSummary[]>('/labs/', params);
  }

  async getLab(labSlug: string): Promise<Lab> {
    return apiClient.get<Lab>(`/labs/${labSlug}`);
  }

  async getRuns(params?: QueryParams): Promise<Run[]> {
    return apiClient.get<Run[]>('/runs/', params);
  }

  async createRun(runData: RunCreate): Promise<Run> {
    return apiClient.post<Run>('/runs/', runData);
  }

  async getRun(runId: number): Promise<Run> {
    return apiClient.get<Run>(`/runs/${runId}`);
  }

  async extendTTL(runId: number, extension: RunExtend): Promise<Run> {
    return apiClient.post<Run>(`/runs/${runId}/extend`, extension);
  }

  async destroyRun(runId: number): Promise<{ message: string }> {
    return apiClient.delete(`/runs/${runId}`);
  }

  async gradeRun(runId: number): Promise<{ message: string; job_id: string }> {
    return apiClient.post(`/runs/${runId}/grade`);
  }

  async getGradeReport(runId: number): Promise<Grade> {
    return apiClient.get<Grade>(`/runs/${runId}/report`);
  }

  async overrideGrade(
    gradeId: number,
    newScore: number,
    comment: string
  ): Promise<Grade> {
    return apiClient.post<Grade>(`/grades/${gradeId}/override`, {
      new_score: newScore,
      comment,
    });
  }

  // Instructor-specific endpoints
  async getAllRuns(params?: QueryParams): Promise<Run[]> {
    return apiClient.get<Run[]>('/instructor/runs', params);
  }

  async getRunGrades(params?: QueryParams): Promise<Grade[]> {
    return apiClient.get<Grade[]>('/instructor/grades', params);
  }
}

export const labService = new LabService();
